import { createT } from './account-i18n.js';
const t = createT('expandableTextData', () => window.expandableTextData && window.expandableTextData.i18n);

class ExpandableTextBlock {
  constructor(blockSelector) {
    this.blockSelector = blockSelector;
    this.initExpandableSections();
  }

  initExpandableSections() {
    const blocks = document.querySelectorAll(this.blockSelector);
    blocks.forEach(block => {
      const readMoreBtn = block.querySelector('.read-more-btn');
      const afterReadMoreContent = block.querySelector('.after-read-more');
      if (readMoreBtn && afterReadMoreContent) {
        readMoreBtn.addEventListener('click', () => this.toggleContent(afterReadMoreContent, readMoreBtn));
      }
    });
  }

  toggleContent(afterReadMoreContent, readMoreBtn) {
    const isExpanded = afterReadMoreContent.classList.contains('expanded');
    afterReadMoreContent.classList.toggle('expanded', !isExpanded);
    readMoreBtn.textContent = isExpanded ? t('readMore') : t('readLess');
  }
}

new ExpandableTextBlock('.expandable-text-block');
